require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-lauren-bauml.json") })
        }
      }, "path---blog-author-lauren-bauml");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-lauren-bauml!./.cache/json/blog-author-lauren-bauml.json
// module id = 668
// module chunks = 231608221292675